<template>
  <div class="page-list-types">
    <PageHeader>
      <h1>Widgets</h1>

      <router-link class="btn is-primary" :to="{name: 'add-list-type'}">
        Add Widget
      </router-link>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <table-data
            :rows="listTypes"
            @reorderItems="reorderItems"
            sortable
            :headings="[
            {heading: 'Widget Name', key: 'list-type-name'},
            ]"
            :pagination="pagination"
          >
            <div
              v-for="(listType, index) in listTypes"
              :slot="'td-' + index + '-list-type-name'"
              :key="index"
            >
              <router-link
                :to="{name: 'list-type', params: {listTypeId: listType.id}}"
              >
                <span class="list-type-name"
                  >{{ listType.name | humanize }}
                </span>
              </router-link>
            </div>
          </table-data>

          <pagination @changePage="changePage" :pagination="pageData">
          </pagination>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Widgets</h1>
            <p>
              Widgets, otherwise known as "List types", can be added to a web pages.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readListTypesData, updateListTypeData} from '@/lib/list_types'

import Table from '@/components/Table'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'

import debounce from 'lodash.debounce'

export default {
  name: 'ListTypes',

  mixins: [page, pagination],

  components: {
    TableData: Table,
    PageHeader,
    PageSummary
  },

  data() {
    return {
      listTypes: [],
      errors: {},
      title: 'List Types'
    }
  },

  methods: {
    getData() {
      readListTypesData(this.pagination).then(({data, page}) => {
        this.pageData = page

        this.listTypes = data.sort((a, b) => (a.weight > b.weight ? 1 : -1))
      })
    },

    updateListTypeWeights(items) {
      items.forEach((item, index) => {
        item.weight = index

        updateListTypeData(item.id, item)
          .then(({data}) => {
            this.$emit('updatePage')
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      })
    }
  },

  filters: {
    humanize(value) {
      return value.replace(/-/g, ' ')
    }
  },

  mounted() {
    this.getData()
  },

  created() {
    this.reorderItems = debounce(
      (items) => {
        this.updateListTypeWeights(items)
      },
      333,
      {trailing: true}
    )
  },

  watch: {
    $route: function() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-list-types
  @extend %page

  .list-type-name
    text-transform: capitalize
</style>
